import React, { useState, useEffect } from "react";
import { numberFormat } from "../../../../helpers/numberFormat";
import { useSelector } from "react-redux";
import { bca, mandiri, bni, bri, permata } from "../../../../assets";

const SummaryPembayaranIndividu = (props) => {
  const np = useSelector((state) => state.nominalPayment);
  const dataInputRegistration = useSelector(
    (state) => state.dataInputRegistration
  );
  const categoryUser = useSelector((state) => state.categoryUserSelected);
  // const [pymManual, setPymManual] = useState(dataInputRegistration.isUsingEarlyBird)

  const size = useWindowSize();

  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }

  const [isPaymentManual, setIsPaymentManual] = useState(false);

  // console.log(dataInputRegistration);

  return (
    <>
      <div className="row mb-3">
        <div className="card" style={{ backgroundColor: "#F2F2F2" }}>
          <div className="card-body">
            <div className="row">
              <h1
                style={{
                  fontSize: "17px",
                  fontWeight: "700",
                  marginBottom: "5px",
                }}
              >
                Syarat Ketentuan Pengembalian Dana
              </h1>
              <hr></hr>
              <ul>
                <li className="mb-2">
                  1. Pembatalan dan Pengembalian biaya maksimal h-5 sebelum
                  kelas dimulai.
                </li>
                <li className="mb-2">
                  2. Pembatalan yang dilakukan setelah konfirmasi kelas tidak
                  dapat dikembalikan namun dapat dialihkan ke jadwal atau topik
                  lain.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="card" style={{ backgroundColor: "#F2F2F2" }}>
          <div className="card-body">
            <div className="row">
              <h1
                style={{
                  fontSize: "17px",
                  fontWeight: "700",
                  marginBottom: "20px",
                }}
              >
                Pilih Pembayaran
              </h1>
              {categoryUser.value === "corporate" ? (
                <>
                  <div
                    className="form-check form-check-custom form-check-white"
                    s1tyle={{ marginTop: "5%", marginBottom: "5%" }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      defaultValue
                      id="TransferManual"
                      onClick={() => setIsPaymentManual(true)}
                      checked={isPaymentManual}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="TransferManual"
                    >
                      <b style={{ fontSize: "16px", fontWeight: "600" }}>
                        Bank Transfer
                      </b>
                      <br></br>
                      <div className="row mt-3">
                        <div className="col-lg-4 col-md-6 mb-3">
                          <img src={bca} alt="bca" width={80} />
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <img src={mandiri} alt="mandiri" width={80} />
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <img src={bri} alt="bri" width={80} />
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <img src={bni} alt="bni" width={80} />
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                          <img src={permata} alt="permata" width={130} />
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="row mb-3">
                    <div
                      className="col-lg-12"
                      style={{ backgroundColor: "#FFF3CD" }}
                    >
                      <div
                        className="col-lg-10"
                        style={{ color: "#856404", marginBottom: "3%" }}
                      >
                        {size.width < 500 ? (
                          <>
                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                color: "#191919",
                                margin: "2%",
                              }}
                            >
                              Cara Pembayaran Via Transfer
                            </p>
                            <ul>
                              <li
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "400",
                                  color: "#191919",
                                }}
                              >
                                1. Transfer ke nomor rekening bank yang tertera
                                dibawah ini :
                                <ul>
                                  <li>
                                    <div className="row d-flex mt-1 mb-1">
                                      <div className="col-12">Nama Bank :</div>
                                      <div className="col-12">
                                        <b>BCA Serpong Branch</b>
                                      </div>
                                    </div>
                                    <div className="row mb-1">
                                      <div className="col-12">
                                        Nomor Rekening Bank :
                                      </div>
                                      <div className="col-12">
                                        <b>497 6700 988</b>
                                      </div>
                                    </div>
                                    <div className="row mb-1">
                                      <div className="col-12">
                                        Nama Rekening Bank :
                                      </div>
                                      <div className="col-12">
                                        A/N <b>PT. Prasetiya Mulya ELI</b>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </li>
                              <li
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "400",
                                  color: "#191919",
                                }}
                              >
                                2. Simpan notifikasi / struk transaksi sebagai
                                bukti pembayaran.
                              </li>
                              <li
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "400",
                                  color: "#191919",
                                }}
                              >
                                3. Upload bukti pembayaran di dashboard Riwayat
                                Transaksi.
                              </li>
                            </ul>
                          </>
                        ) : (
                          <>
                            <p
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#191919",
                                margin: "2%",
                              }}
                            >
                              Cara Pembayaran Via Transfer Bank
                            </p>
                            <ul>
                              <li
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  color: "#191919",
                                }}
                              >
                                1. Transfer ke nomor rekening bank yang tertera
                                dibawah ini :
                                <ul>
                                  <li>
                                    <div className="row mt-1 mb-1">
                                      <div className="col-lg-6">Nama Bank</div>
                                      <div className="col-lg-6">
                                        : <b>BCA Serpong Branch</b>
                                      </div>
                                    </div>
                                    <div className="row mb-1">
                                      <div className="col-lg-6">
                                        Nomor Rekening Bank
                                      </div>
                                      <div className="col-lg-6">
                                        : <b>497 6700 988</b>
                                      </div>
                                    </div>
                                    <div className="row mb-1">
                                      <div className="col-lg-6">
                                        Nama Rekening Bank
                                      </div>
                                      <div className="col-lg-6">
                                        : A/N <b>PT. Prasetiya Mulya ELI</b>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </li>
                              <li
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  color: "#191919",
                                }}
                              >
                                2. Simpan notifikasi / struk transaksi sebagai
                                bukti pembayaran.
                              </li>
                              <li
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  color: "#191919",
                                }}
                              >
                                3. Upload bukti pembayaran di dashboard Riwayat
                                Transaksi.
                              </li>
                            </ul>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              <>
                <hr></hr>
                <div
                  className="form-check form-check-custom form-check-white"
                  style={{ marginTop: "1%" }}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    defaultValue
                    id="Midtrans"
                    onClick={() => setIsPaymentManual(false)}
                    checked={!isPaymentManual}
                  />
                  <label className="form-check-label" htmlFor="Midtrans">
                    <b style={{ fontSize: "16px", fontWeight: "600" }}>
                      Transfer VA
                    </b>{" "}
                    <span style={{ fontSize: "16px" }}>(Virtual Account)</span>
                  </label>
                  <div className="row mt-3">
                    {size.width < 500 ? (
                      <>
                        <div className="row">
                          <div className="col-sm-12">
                            <img src={bca} alt="bca" width={35} />
                          </div>
                          <div className="col-sm-12">
                            <img src={mandiri} alt="mandiri" width={35} />
                          </div>
                          <div className="col-sm-12">
                            <img src={bri} alt="bri" width={35} />
                          </div>
                          <div className="col-sm-12">
                            <img src={bni} alt="bni" width={35} />
                          </div>
                          <div className="col-sm-12">
                            <img src={permata} alt="permata" width={35} />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="row">
                          <div className="col-lg-4 col-md-6 mb-3">
                            <img src={bca} alt="bca" width={80} />
                          </div>
                          <div className="col-lg-4 col-md-6 mb-3">
                            <img src={mandiri} alt="mandiri" width={80} />
                          </div>
                          <div className="col-lg-4 col-md-6 mb-3">
                            <img src={bri} alt="bri" width={80} />
                          </div>
                          <div className="col-lg-4 col-md-6 mb-3">
                            <img src={bni} alt="bni" width={80} />
                          </div>
                          <div className="col-lg-4 col-md-6 mb-3">
                            <img src={permata} alt="permata" width={130} />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
      {dataInputRegistration.isUsingEarlyBird === true ||
        dataInputRegistration.isUsingReferral === true ? (
        <>
          <div className="row mb-3">
            <div className="card" style={{ backgroundColor: "#F2F2F2" }}>
              <div className="card-body">
                <div className="row">
                  <h1
                    style={{
                      fontSize: "17px",
                      fontWeight: "700",
                      marginBottom: "5px",
                    }}
                  >
                    Panduan Pembayaran
                  </h1>
                  <hr></hr>
                  <ul>
                    <li className="mb-2">
                      1. Pembayaran anda akan di proses melalui{" "}
                      <b>platform pembayaran</b>, sebuah platform pembayaran
                      yang aman dan cepat.
                    </li>
                    <li className="mb-2">
                      2. Setelah <b>Klik "Bayar"</b>, anda harus menyelesaikan
                      pembayaran sebelum <b>due date</b> berakhir.
                    </li>
                    <li className="mb-2">
                      3. Anda akan menerima <b>email invoice</b> dari{" "}
                      <b>platform pembayaran</b> kami, anda dapat mengikuti
                      langkah-langkah dalam email tersebut untuk menyelesaikan
                      transaksi.
                    </li>
                    <li className="mb-2">
                      Jika pembayaran tidak diselesaikan sebelum <b>due date</b>
                      , transaksi akan di batalkan.
                    </li>
                    <li className="mb-2">
                      4. Jika ingin melakukan pembayaran di luar channel
                      pembayaran kami, silahkan menghubungi Customer Service
                      kami di : <b>+62 811-1991-1168</b> atau melalui fitur chat
                      di halaman registrasi ini.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      <div className="row mb-3">
        <div className="card" style={{ backgroundColor: "#F2F2F2" }}>
          <div className="card-body">
            <div className="row">
              <h1
                style={{
                  fontSize: "17px",
                  fontWeight: "700",
                  marginBottom: "5px",
                }}
              >
                Ringkasan Pembayaran
              </h1>
              <hr></hr>
              <div
                className="d-flex justify-content-between"
                style={{ marginTop: "5%" }}
              >
                <p style={{ fontSize: "14px", fontWeight: "400" }}>Sub Total</p>
                <p style={{ fontSize: "16px", fontWeight: "600" }}>
                  Rp. {numberFormat(np.nominalPayment.amount)}
                </p>
              </div>
              <div
                className="d-flex justify-content-between"
                style={{ marginTop: "2%" }}
              >
                <p style={{ fontSize: "14px", fontWeight: "400" }}>PPN (12%)</p>
                <p style={{ fontSize: "16px", fontWeight: "600" }}>
                  Rp. {numberFormat(np.nominalPayment.ppn)}
                </p>
              </div>
              <div
                className="d-flex justify-content-between"
                style={{ marginTop: "2%" }}
              >
                <p style={{ fontSize: "14px", fontWeight: "400" }}>
                  Potongan Harga
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#F1416C",
                  }}
                >
                  - (Rp. {numberFormat(np.nominalPayment.deduction)})
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <p style={{ fontSize: "16px", fontWeight: "700" }}>Total</p>
          <p style={{ fontSize: "18px", fontWeight: "700", color: "#0C86D9" }}>
            Rp. {numberFormat(np.nominalPayment.grandtotal)}
          </p>
        </div>
        <div className="col-lg-6" style={{ textAlign: "right" }}>
          {categoryUser.value === "corporate" ? (
            isPaymentManual === true ? (
              <button
                onClick={props.checkOutManualCorporate}
                style={{ fontSize: "20px", fontWeight: "400" }}
                className="btn btn-success"
                disabled={dataInputRegistration.disabledRegistration}
              >
                {dataInputRegistration.disabledRegistration ? 'Mohon Tunggu..' : 'Bayar'}
              </button>
            ) : (
              <button
                onClick={props.checkOutXenditCorporate}
                style={{ fontSize: "20px", fontWeight: "400" }}
                className="btn btn-success"
                disabled={dataInputRegistration.disabledRegistration}
              >
                {dataInputRegistration.disabledRegistration ? 'Mohon Tunggu..' : 'Bayar'}
              </button>
            )
          ) : (
            <button
              onClick={props.checkOutMidtrans}
              style={{ fontSize: "20px", fontWeight: "400" }}
              className="btn btn-success"
              disabled={dataInputRegistration.disabledRegistration}
            >
              {dataInputRegistration.disabledRegistration ? 'Mohon Tunggu..' : 'Bayar'}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default SummaryPembayaranIndividu;
